import React from 'react';
import classnames from 'classnames'
import { PropTypes } from 'prop-types';
import './Buttons.scss'
import HrbTranslate from '../../language/HrbTranslate';

const ToggleButton = ({ elementId, value, pendingValue, options, labels, onChange }) =>
    <div id={elementId} className="toggle-buttons">
        {options.map((option, i) => {
            let isSelected = value?.toLowerCase() === option.toLowerCase()
            let isPending = (pendingValue || '').toLowerCase() === option.toLowerCase() && pendingValue !== value

            let classNames = classnames('button', {
                'is-selected': isSelected,
                'is-loading': isPending
            })
            let label = !!labels ? <HrbTranslate text={labels[i]} /> : options[i]

            const handleClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange(option.toLowerCase());
            }

            return (
                <span key={option} id={`${elementId}-${option.toLowerCase()}`} className={classNames} onClick={handleClick}>
                    {!isPending && label}
                </span>)
        })}
    </div>

ToggleButton.propTypes = {
    elementId: PropTypes.string.isRequired,
    pendingValue: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string),
    labels: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func
}

export default ToggleButton;